// extracted by mini-css-extract-plugin
export var table = "_xr-0";